// extracted by mini-css-extract-plugin
export var menuIcon = "_ml-0";
export var menuIconInline = "_ml-1";